import { all } from 'async-saga';
import { actions } from '..';
import { callTranscriptionSubscribe, deleteCallTranscriptionTag, getCallTranscriptionBookmarks, getCallTranscriptions, Sentiment, setCallTranscriptionTag, setCallTranscriptionTagTitle, setCallTranscriptionText, setParagraphSentiment } from '../../api/transcriptions';
import { selectConfigProp } from '../reducers/config';
import { selectMedia } from '../reducers/media';
import { selectTranscriptionParagraph } from '../reducers/transcriptions';
import { takeEvery } from '../tools/async-saga-types';

const onFetchCallTranscriptionRequest = takeEvery(actions.fetchCallTranscriptionRequest, async function (ctx, { mediaId }) {
  const state = ctx.getState();
  const media = selectMedia(state, mediaId)
  const transcriptionEnabled = selectConfigProp(state, 'transcriptionEnabled')

  if (!transcriptionEnabled) return

  if (media && (media.mediaType === 'CALL' || media.mediaType === 'VM')) {
    const result = await callTranscriptionSubscribe(media.id)
    if (result && result.success) {
      ctx.dispatch(actions.fetchCallTranscriptionResponse(mediaId, { ...result.data, sentiment: Sentiment.none, negative: 0, neutral: 0, positive: 0 }))
    }
  } else {
    let page = 0;
    let sentiment = Sentiment.none
    let neutral
    let negative
    let positive
    while (true) {
      const result = await getCallTranscriptions(mediaId, page)
      const values = result.userdata.data.split(',')
      sentiment = parseFloat(values[0])
      neutral = parseFloat(values[1])
      negative = parseFloat(values[2])
      positive = parseFloat(values[3])

      ctx.dispatch(actions.fetchCallTranscriptionResponse(mediaId, { calls: [], paragraphs: result.rows, sentiment: Sentiment.none, negative: 0, neutral: 0, positive: 0 }))
      if (result.total > page + 1) {
        page += 1
      } else {
        break;
      }
    }

    ctx.dispatch(actions.notifySentimentCall(mediaId, sentiment, '', neutral, negative, positive))

    const tags = await getCallTranscriptionBookmarks(mediaId)
    if (tags) {
      ctx.dispatch(actions.fetchCallTranscriptionTagsResponse(mediaId, tags))
    }
  }
})

const onUpdateCallTransactionTag = takeEvery(actions.requestCallTranscriptionTag, async function (ctx, { mediaId, tagId, tag, timeStamp, type }) {
  //update server
  const result = tagId ? await setCallTranscriptionTagTitle(tagId, tag) : await setCallTranscriptionTag(mediaId, tag, type, timeStamp)

  if (result.success) {
    if (!tagId) {
      ctx.dispatch(actions.showClientNotification('Tag created.'))
    }
    else {
      ctx.dispatch(actions.showClientNotification('Tag updated.'))
    }
  }
  else {
    ctx.dispatch(actions.showClientNotification('There was an issue creating the paragraph tag.'))
  }
})

const onUpdateCallTransaction = takeEvery(actions.updateCallTranscriptionText, async function (ctx, { mediaId, paragraphId, text }) {
  const paragraph = selectTranscriptionParagraph(ctx.getState(), { mediaId, paragraphId })
  if (paragraph) {
    //update server
    const result = await setCallTranscriptionText(paragraphId, text)
    if (result.success) {
      ctx.dispatch(actions.requestTranscriptionParagraphOrginal(mediaId, paragraphId, paragraph.text))
      ctx.dispatch(actions.showClientNotification('Paragraph updated.'))
    }
    else {
      ctx.dispatch(actions.showClientNotification('There was an issue updating the paragraph.'))
    }
  }
})

const onRequestTranscriptionParagraphRevert = takeEvery(actions.requestTranscriptionParagraphRevert, async function (ctx, { mediaId, paragraphId }) {
  const paragraph = selectTranscriptionParagraph(ctx.getState(), { mediaId, paragraphId })
  if (paragraph && paragraph.original) {
    //update server
    const result = await setCallTranscriptionText(paragraphId, paragraph.original)
    if (result.success) {
      ctx.dispatch(actions.requestTranscriptionParagraphOrginal(mediaId, paragraphId, undefined))
      ctx.dispatch(actions.showClientNotification('Paragraph reverted.'))
    }
    else {
      ctx.dispatch(actions.showClientNotification('There was an issue reverting the paragraph.'))
    }
  }
})

const onRequestSetSentiment = takeEvery(actions.requestSetSentiment, async function (ctx, { paragraphId, sentiment }) {
  const result = await setParagraphSentiment(paragraphId, sentiment)
  if (!result.success) {
    ctx.dispatch(actions.showClientNotification(result.error))
  }
})

const onRequestDeleteBookmark = takeEvery(actions.requestDeleteCallTranscriptionTag, async function (ctx, { mediaId, tagId }) {
  const result = await deleteCallTranscriptionTag(tagId)
  if (!result.success) {
    ctx.dispatch(actions.showClientNotification("There was an issue removing the bookmark"))
  }
})

export default all(
  onUpdateCallTransactionTag,
  onUpdateCallTransaction,
  onFetchCallTranscriptionRequest,
  onRequestTranscriptionParagraphRevert,
  onRequestSetSentiment,
  onRequestDeleteBookmark,
)
